import { render, staticRenderFns } from "./RadioInput.vue?vue&type=template&id=f2a05902&scoped=true"
import script from "./RadioInput.vue?vue&type=script&lang=js"
export * from "./RadioInput.vue?vue&type=script&lang=js"
import style0 from "./RadioInput.vue?vue&type=style&index=0&id=f2a05902&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2a05902",
  null
  
)

export default component.exports